import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react"
import { ArrowDown } from "./icons"
import { LangLink } from "./LangLink"
import { Form, useLocation, useRouteLoaderData, useSearchParams } from "@remix-run/react";
import type { RootData } from "~/root";
import { redirectToRegister, redirectToLoginUrl, useRootLoaderData } from "~/apis/utils";

export function MyAccountComponent() {
	const { user } = useRootLoaderData();
	const location = useLocation();
	const [searchParams] = useSearchParams();
	if (!user) return <div className="flex gap-x-2 items-center">
		<LangLink to={`${redirectToLoginUrl(location, searchParams)}`} className="btn-light-sm">Login</LangLink>
		<LangLink to={`${redirectToRegister(location, searchParams)}`} className="btn-dark-sm">Register</LangLink>
	</div>
	return <Menu as="div" className="relative inline-block text-left">
		<div>
			<MenuButton className="inline-flex items-center gap-1 my-account-item">
				<span>{user.fullName}</span>
				<ArrowDown aria-hidden="true" className="size-4 mt-1 text-slate-700" />
			</MenuButton>
		</div>

		<MenuItems
			transition
			className="absolute right-0 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
		>
			<div className="py-1">
				<MenuItem>
					<LangLink to="/account-settings"
						className="block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900"
					>
						Account settings
					</LangLink>
				</MenuItem>
				{!user.authenticationmethod ? <MenuItem>
					<LangLink to="/reset-password"
						className="block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900"
					>
						Reset password
					</LangLink>
				</MenuItem> : null}
				<Form action="/logout" method="POST">
					<MenuItem>
						<button
							type="submit"
							className="block w-full px-4 py-2 text-left text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900"
						>
							Sign out
						</button>
					</MenuItem>
				</Form>
			</div>
		</MenuItems>
	</Menu>
}